import React from 'react';
import { SigningDocumentCover } from 'src/components';
import { AgreementsArchiveCard } from '../../components/AgreementsCard';
import { CoverWrapper } from 'src/components/Cover/styles.ts';

const Archive = () => {
  return (
    <>
      <CoverWrapper>
        <SigningDocumentCover />
      </CoverWrapper>
      <AgreementsArchiveCard />
    </>
  );
};

export default Archive;
